import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen bg-[#2A382A] text-white">
      <Navbar isTransparent={true} hasWhiteBackground={false} />
      {children}
      {!hideFooter && <Footer />}
    </div>
  );
}

export default Layout;